import { graphql } from 'gatsby';

export const MainNavigationFragment = graphql`
    fragment PrismicMainNavigationFragment on PRISMIC_Main_navigation {
        ...MetaFragment
        menu_items {
            label
            link {
                ...LinkFragment
            }
        }
        logout_label
        go_to_app_label
        login_label
        signup_label
    }
`;
